export function createBlackoutPattern(): CanvasPattern | string {
  const canvas = document.createElement('canvas');
  canvas.width = 8;
  canvas.height = 8;
  const ctx = canvas.getContext('2d');
  if (!ctx) return 'rgba(40,40,40,0.8)';
  ctx.fillStyle = 'rgba(30,30,30,0.85)';
  ctx.fillRect(0, 0, 8, 8);
  ctx.strokeStyle = 'rgba(160,20,20,0.85)';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(0, 8);
  ctx.lineTo(8, 0);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(-4, 4);
  ctx.lineTo(4, -4);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(4, 12);
  ctx.lineTo(12, 4);
  ctx.stroke();
  return ctx.createPattern(canvas, 'repeat') ?? 'rgba(40,40,40,0.8)';
}
